$(document).ready(function () {
  function openCart() {
    buildCart();
    $("body").addClass("Overflow_hidden");
    $("body").addClass("overflow-hidden");
    $(".nr_cart_drawer_outer").css("display", "flex");

    setTimeout(function () {
      $(".nr_cart_drawer_outer").addClass("active");
      // $('.cd_upsells_carousel').slick('refresh');
    }, 100);
  }

  $(".bdtr_containaer_out").addClass("loaded");

  $(".bdru_carousel").slick({
    dots: false,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "80px",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "30px",
        },
      },
    ],
  });

  $(".bd_aths_cont:not(.slick-progress)").slick({
    dots: false,
    arrows: false,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_11.png?v=1724852466'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_12.png?v=1724852466'/></button>",
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          dots: true,
          centerPadding: "30px",
        },
      },
    ],
  });

  $(".bdrs_carousel").slick({
    dots: false,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_11.png?v=1724852466'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_12.png?v=1724852466'/></button>",
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "80px",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "30px",
        },
      },
    ],
  });

  $(".bdrs_carousel_upd").slick({
    dots: true,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "80px",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "30px",
        },
      },
    ],
  });

  $(".bdp_gallery_main").slick({
    dots: false,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".bdp_gallery_thumb",
    cssEase: "linear",
  });

  $(".bdp_gallery_thumb").slick({
    dots: false,
    arrows: false,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_11.png?v=1724852466'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_12.png?v=1724852466'/></button>",
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".bdp_gallery_main",
    cssEase: "linear",
    focusOnSelect: true,
  });

  $(".bdp_sub_form_inn_header").click(function () {
    $(this).closest('.bdp_form').find(".bdp_sub_form").removeClass("active");
    $(this).closest(".bdp_sub_form").addClass("active");

    $(this)
      .closest(".bdp_sub_form_inner")
      .find(".bdp_quantity_selector.first_load_selected")
      .trigger("click");
  });


  $(".bdp_exp_box").click(function () {
    $(this).find(".bdp_exp_info").slideToggle();
  });

  $(".bdp_sub_ann").click(function () {
    $(this)
      .closest(".bdp_sub_form")
      .find(".bdp_sub_form_inn_header")
      .trigger("click");
  });

  $(".bdp_quantity_selector").click(function () {
    $(this).closest('.bdp_form').find(".bdp_quantity_selector").removeClass("active");
    $(this).addClass("active");

    var currentPrice = $(this).attr("data-price");
    var comparePrice = $(this).attr("data-compare-price");

    $(".Onetime_pricing s").html(comparePrice);
    $(".Onetime_pricing p").html(currentPrice);
  });

  // $('.bdp_atc').click(function(evt){

  //   evt.preventDefault();
  //   var mode = $('.bdp_sub_form.active').attr('data-mode');
  //   if (mode == 'onetime'){

  //       var currentId = $('.bdp_sub_form.active').attr('data-id');
  //       var currentQty  = parseFloat($('.bdp_quantity_selector.active').attr('data-qty'));

  //     console.log(currentQty);
  //       if (currentQty == 3){
  //         var items = [];
  //         var giftId = 44565214396593;
  //          items.push({ id: currentId, quantity: 3 });
  //          items.push({ id: giftId, quantity: 1 });

  //         $.ajax({
  //           type: "POST",
  //           url: "/cart/add.js",
  //           data: {
  //             items: items,
  //           },
  //           dataType: "json",
  //           success: function (data) {
  //              window.location.href = '/cart';
  //           },
  //         });
  //       }
  //       else{
  //         var data = {
  //           id: currentId,
  //           quantity: currentQty
  //         };
  //         console.log(data);

  //         jQuery.ajax({
  //           type: "POST",
  //           url: "/cart/add.js",
  //           data: data,
  //           dataType: "json",
  //           success: function () {
  //             window.location.href = '/cart';
  //           },
  //         });
  //       }

  //   }
  //   else if ( mode == 'sub'){
  //     var currentId = $('.bdp_sub_form.active').attr('data-id');
  //     var currentQty  = parseFloat($('.bdp_quantity_selector.active').attr('data-qty'));

  //     var selling_plan =  1313734833;

  //     var data = {
  //       id: currentId,
  //       quantity: currentQty,
  //       selling_plan: selling_plan
  //     };
  //     console.log(data);

  //     jQuery.ajax({
  //       type: "POST",
  //       url: "/cart/add.js",
  //       data: data,
  //       dataType: "json",
  //       success: function () {
  //         window.location.href = '/cart';
  //       },
  //     });
  //   }

  // });

  $(".pu_atc_btn").click(function () {
    $(".pu_outer").css("filter", "brightness(0.5)");
    setTimeout(function () {
      $(".pu_outer").hide();
    }, 500);

    var mode = $(".bdp_sub_form.active").attr("data-mode");
    var currentId = $(".pu_decline_btn").attr("data-id");
    var currentQty = parseFloat(
      $(".bdp_quantity_selector.active").attr("data-qty")
    );
    var currentOfferId = $(this).attr("data-id");

    // var currentId = $('.bdp_sub_form.active .bdp_quantity_selector.active').attr('data-id');

    // jQuery.ajax({
    //   type: "POST",
    //   url: "/cart/clear.js",
    //   dataType: "json",
    //   success: function() {

    //   },
    //   error: function() {
    //       alert('Error clearing the cart.');
    //   }
    // });

    if (mode == "onetime") {
      if (currentId == "44908505399473") {
        var items = [];
        var giftId = 44908504154289;
        items.push({ id: currentId, quantity: 1 });
        items.push({ id: giftId, quantity: 1 });
        items.push({ id: currentOfferId, quantity: 1 });

        // Add the items to the cart
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: items,
          },
          dataType: "json",
          success: function (data) {
            openCart();
          },
          error: function () {
            alert("Error adding the items to the cart.");
          },
        });
      } else if (currentId == "44908505432241") {
        var items = [];
        var giftId = 44908504187057;
        items.push({ id: currentId, quantity: 1 });
        items.push({ id: giftId, quantity: 1 });
        items.push({ id: currentOfferId, quantity: 1 });

        // Add the items to the cart
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: items,
          },
          dataType: "json",
          success: function (data) {
            openCart();
          },
          error: function () {
            alert("Error adding the items to the cart.");
          },
        });
      } else {
        var items = [];
        var giftId = 44908504187057;
        items.push({ id: currentId, quantity: 1 });
        // items.push({ id: giftId, quantity: 1 });
        items.push({ id: currentOfferId, quantity: 1 });

        // Add the items to the cart
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: items,
          },
          dataType: "json",
          success: function (data) {
            openCart();
          },
          error: function () {
            alert("Error adding the items to the cart.");
          },
        });
      }
    } else if (mode == "sub") {
      var selling_plan = 1313734833;

      var data = {
        id: currentId,
        quantity: currentQty,
        selling_plan: selling_plan,
      };

      // Add the subscription item to the cart
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          openCart();
        },
        error: function () {
          alert("Error adding the subscription item to the cart.");
        },
      });
    }
  });

  $(".sa_pp_variant").click(function () {
    $(".sa_pp_variant").removeClass("active");
    $(this).addClass("active");
    var currentId = $(".sa_pp_variant.active").attr("data-id");
    $(".sa_btn_price").hide();
    $('.sa_btn_price[data-id="' + currentId + '"]').show();
  });

  $(".sa_pp_atc_btn").click(function (evt) {
    evt.preventDefault();
    var currentId = $(".sa_pp_variant.active").attr("data-id");
    $(".pu_outer").css("display", "flex");
    $(".pu_decline_btn").attr("data-id", currentId);
    $(".pu_outer").css("filter", "brightness(1)");
  });

  $(".pu_decline_btn").click(function () {
    $(".pu_outer").css("filter", "brightness(0.5)");
    setTimeout(function () {
      $(".pu_outer").hide();
    }, 500);

    var mode = $(this).attr("data-mode") || $(".bdp_sub_form.active").attr("data-mode");
    var currentId = $(this).attr("data-id");

    console.log("Popup Decline", {
      mode,
      currentId,
    });

    var currentQty =
      1 || parseFloat($(".bdp_quantity_selector.active").attr("data-qty"));

    if (String(window.location.href).indexOf("quiz") != -1) {
      var currentId = $(".bdp_quantity_selector.active").attr("data-id");
      var currentQtyIndex = currentQty;
      currentQty = 1;
    }

    if (String(window.location.href).indexOf("quiz") != -1) {
      if (mode == "onetime") {
        if (currentId == "44908505399473") {
          var items = [];
          var giftId = 44908504154289;
          items.push({ id: currentId, quantity: 1 });
          items.push({ id: giftId, quantity: 1 });

          // Add the items to the cart
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              items: items,
            },
            dataType: "json",
            success: function (data) {
              openCart();
            },
            error: function () {
              alert("Error adding the items to the cart.");
            },
          });
        } else if (currentId == "44908505432241") {
          var items = [];
          var giftId = 44908504187057;
          items.push({ id: currentId, quantity: 1 });
          items.push({ id: giftId, quantity: 1 });

          // Add the items to the cart
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              items: items,
            },
            dataType: "json",
            success: function (data) {
              openCart();
            },
            error: function () {
              alert("Error adding the items to the cart.");
            },
          });
        } else {
          var data = {
            id: currentId,
            quantity: currentQty,
          };

          // Add the single item to the cart
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              openCart();
            },
            error: function () {
              alert("Error adding the item to the cart.");
            },
          });
        }
      }
    } else {
      if (mode == "onetime") {
        if (currentId == "44908505399473") {
          var items = [];
          var giftId = 44908504154289;
          items.push({ id: currentId, quantity: 1 });
          items.push({ id: giftId, quantity: 1 });

          // Add the items to the cart
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              items: items,
            },
            dataType: "json",
            success: function (data) {
              openCart();
            },
            error: function () {
              alert("Error adding the items to the cart.");
            },
          });
        } else if (currentId == "44908505432241") {
          var items = [];
          var giftId = 44908504187057;
          items.push({ id: currentId, quantity: 1 });
          items.push({ id: giftId, quantity: 1 });

          // Add the items to the cart
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              items: items,
            },
            dataType: "json",
            success: function (data) {
              openCart();
            },
            error: function () {
              alert("Error adding the items to the cart.");
            },
          });
        } else {
          var data = {
            id: currentId,
            quantity: currentQty,
          };

          // Add the single item to the cart
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              openCart();
            },
            error: function () {
              alert("Error adding the item to the cart.");
            },
          });
        }
      } else if (mode == "sub") {
        var selling_plan = 1313734833;

        var data = {
          id: currentId,
          quantity: currentQty,
          selling_plan: selling_plan,
        };

        // Add the subscription item to the cart
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          dataType: "json",
          success: function () {
            openCart();
          },
          error: function () {
            alert("Error adding the subscription item to the cart.");
          },
        });
      }
    }
  });

  // $('.bdp_atc').click(function(evt){
  //     evt.preventDefault();

  //     var mode = $('.bdp_sub_form.active').attr('data-mode');
  //     var currentId = $('.bdp_sub_form.active').attr('data-id');
  //     var currentQty = parseFloat($('.bdp_quantity_selector.active').attr('data-qty'));

  //     if (mode == 'onetime') {
  //       $('.pu_outer').css('display', 'flex');
  //       $('.pu_decline_btn').attr('data-id', currentId);
  //       $('.pu_outer').css('filter', 'brightness(1)');
  //     }
  //     else if ( mode == 'offer'){
  //       var currentQty  = parseFloat($('.bdm_qty_val').html());
  //       // Clear the cart first
  //       jQuery.ajax({
  //         type: "POST",
  //         url: "/cart/clear.js",
  //         dataType: "json",
  //         success: function() {
  //           var items = [];
  //           var giftId = 44565214396593;
  //           items.push({ id: currentId, quantity: currentQty });
  //           // items.push({ id: giftId, quantity: 1 });

  //           // Add the items to the cart
  //           $.ajax({
  //               type: "POST",
  //               url: "/cart/add.js",
  //               data: {
  //                   items: items,
  //               },
  //               dataType: "json",
  //               success: function(data) {
  //                  openCart();
  //               },
  //               error: function() {
  //                   alert('Error adding the items to the cart.');
  //               }
  //           });
  //         },
  //         error: function() {
  //             alert('Error clearing the cart.');
  //         }
  //       });
  //     }
  //     else{
  //       // Clear the cart first
  //       jQuery.ajax({
  //         type: "POST",
  //         url: "/cart/clear.js",
  //         dataType: "json",
  //         success: function() {
  //             if (mode == 'onetime') {
  //                 if (currentQty == 6) {
  //                     var items = [];
  //                     var giftId = 44565214396593;
  //                     items.push({ id: currentId, quantity: 6 });
  //                     items.push({ id: giftId, quantity: 1 });

  //                     // Add the items to the cart
  //                     $.ajax({
  //                         type: "POST",
  //                         url: "/cart/add.js",
  //                         data: {
  //                             items: items,
  //                         },
  //                         dataType: "json",
  //                         success: function(data) {
  //                            openCart();
  //                         },
  //                         error: function() {
  //                             alert('Error adding the items to the cart.');
  //                         }
  //                     });
  //                 } else {
  //                     var data = {
  //                         id: currentId,
  //                         quantity: currentQty
  //                     };

  //                     // Add the single item to the cart
  //                     jQuery.ajax({
  //                         type: "POST",
  //                         url: "/cart/add.js",
  //                         data: data,
  //                         dataType: "json",
  //                         success: function() {
  //                            openCart();
  //                         },
  //                         error: function() {
  //                             alert('Error adding the item to the cart.');
  //                         }
  //                     });
  //                 }
  //             } else if (mode == 'sub') {
  //                 var selling_plan = 1313734833;

  //                 var data = {
  //                     id: currentId,
  //                     quantity: currentQty,
  //                     selling_plan: selling_plan
  //                 };

  //                 // Add the subscription item to the cart
  //                 jQuery.ajax({
  //                     type: "POST",
  //                     url: "/cart/add.js",
  //                     data: data,
  //                     dataType: "json",
  //                     success: function() {
  //                        openCart();
  //                     },
  //                     error: function() {
  //                         alert('Error adding the subscription item to the cart.');
  //                     }
  //                 });
  //             }
  //         },
  //         error: function() {
  //             alert('Error clearing the cart.');
  //         }
  //       });
  //     }

  // });

  $(".bd_primary_btn").click(function (evt) {
    evt.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $(".bdp_container").offset().top - 100,
      },
      500
    );
  });

  $(".bdtr_review_carousle").slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".bdru_video_out").mouseover(function () {
    $(this).addClass("hovered");
  });

  $(".bdru_video_out").mouseleave(function () {
    $(this).removeClass("hovered");
  });

  $(".bdtim_accord").click(function () {
    $(this).find(".dbtim_accord_info").slideToggle();
  });

  $(".bdru_video_out").click(function () {
    var clickedVideo = $(this).find("video")[0];

    // Pause all other videos except the clicked one
    $(".bdru_video_out").each(function () {
      var video = $(this).find("video")[0];
      if (video && video !== clickedVideo && !video.paused) {
        video.pause();
        $(this).find(".bdru_Control_pause").hide();
        $(this).find(".bdru_Control_play").show();
      }
    });

    // Toggle play/pause for the clicked video
    if (clickedVideo) {
      if (clickedVideo.paused) {
        clickedVideo.play();
        $(this).find(".bdru_Control_pause").show();
        $(this).find(".bdru_Control_play").hide();
      } else {
        clickedVideo.pause();
        $(this).find(".bdru_Control_pause").hide();
        $(this).find(".bdru_Control_play").show();
      }
    }
  });

  $(".bdm_qty_plus").click(function () {
    var currentVal = parseFloat($(".bdm_qty_val").html());
    currentVal++;
    $(".bdm_qty_val").html(currentVal);
    calculatePrice();
  });

  $(".bdm_qty_min").click(function () {
    var currentVal = parseFloat($(".bdm_qty_val").html());
    if (currentVal > 1) {
      currentVal--;
    }

    $(".bdm_qty_val").html(currentVal);
    calculatePrice();
  });

  function calculatePrice() {
    var currentPrice = $(".bdm_qty_val").attr("data-price");
    var currentQty = parseFloat($(".bdm_qty_val").html());

    currentPrice = currentPrice * currentQty;

    currentPrice = (currentPrice / 100).toFixed(2);
    currentPrice = "$" + currentPrice;

    $(".bdo_total_price__js").html(currentPrice);

    if (currentQty == 1) {
      $(".bdo_qty_info__js").html(currentQty + " Jar");
    } else {
      $(".bdo_qty_info__js").html(currentQty + " Jars");
    }

    console.log(currentPrice, " current price");
  }

  function LoadVideos() {
    $(".lazyVideo").each(function () {
      var video = $(this)[0];
      video.play();
      setTimeout(function () {
        video.pause();
      }, 200);
    });
  }

  setTimeout(function () {
    LoadVideos();
  }, 500);

  $(".qz_pr_upd_cell").click(function () {
    $(this)
      .closest(".bdp_sub_form_inner")
      .find(".qz_pr_upd_cell")
      .removeClass("active");
    $(this).addClass("active");
    var variantId = $(this).attr("data-id");

    $(this).closest(".bdp_sub_form_inner").find(".bdp_price_cont_outer").hide();
    $(this)
      .closest(".bdp_sub_form_inner")
      .find('.bdp_price_cont_outer[data-id="' + variantId + '"]')
      .show();
  });

  $('.bdp_atc_simple').click(function (evt) {
    evt.preventDefault();
    var currentQty = 1;
    var currentId = $(this).attr('data-id');

    var items = [];
    items.push({ id: currentId, quantity: currentQty });

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function () {
        openCart();
      },
      error: function () {
        alert("Error adding item to the cart.");
      },
    });
  });

  $(".bdp_atc_quiz").click(function (evt) {
    evt.preventDefault();

    var buttonQuantity = $(".bdp_atc_quiz").attr("data-button");

    var productType = $(this).attr("data");
    var mode = $(this)
      .closest(".bdp_form")
      .find(".bdp_sub_form.active")
      .attr("data-mode");
    if (buttonQuantity == "oneBottle") {
      var currentId = $(".bdp_sub_form.active").attr("data-id");
    } else {
      var currentId = $(this)
        .closest(".bdp_form")
        .find(".bdp_quantity_selector.active")
        .attr("data-id");
    }

    var currentQtyIndex = parseFloat(
      $(this)
        .closest(".bdp_form")
        .find(".bdp_quantity_selector.active")
        .attr("data-qty")
    );
    var currentQty = 1;

    var currentIdSub = $(this)
      .closest(".bdp_form")
      .find(".bdp_sub_form.active")
      .attr("data-id");

    console.log("CURRENT ID IT IS ============", {
      mode,
      currentId,
      currentIdSub,
      currentQtyIndex,
      currentQty,
      productType,
    });

    if (mode == "onetime") {
      var currentPopup = $(this).attr("data-popup");
      if (currentPopup == "pmo") {
        jQuery.getJSON("/cart.js", function (cart) {
          var currentPopup = $(this).attr("data-popup");
          var hasRestrictedItem = cart.items.some(function (item) {
            return item.id === 45193441378481 || item.id === 44652185092273;
          });

          console.log(hasRestrictedItem, "HAS RESTRICTED ITEM");

          if (hasRestrictedItem) {
            var items = [];
            items.push({ id: currentId, quantity: 1 });

            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: {
                items: items,
              },
              dataType: "json",
              success: function () {
                openCart();
              },
              error: function () {
                alert("Error adding item to the cart.");
              },
            });
          } else {
            $(".pmo_outer").css("display", "flex");
            $(".pmo_outer").find(".pmo_accept").attr("data-id", currentId);
            $(".pmo_outer").find(".pmo_decline").attr("data-id", currentId);
          }
        });
      } else {
        $(".pu_outer").css("display", "flex");
        $(".pu_decline_btn").attr("data-id", currentId);
        $(".pu_decline_btn").attr("data-mode", mode);
        $(".pu_outer").css("filter", "brightness(1)");
      }
    } else {
      // Clear the cart first
      jQuery.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function () {
          if (productType == "trial") {
            var selling_plan = $(".bdp_atc_quiz").attr("data-selling-plan");
          } else {
            //  var selling_plan = 1313734833;
            var selling_plan = $(".bdp_atc_quiz").attr("data-selling-plan");
          }

          jQuery.getJSON("/cart.js", function (cart) {
            var currentTrialId = 44969780805809;
            var trialIncart = 0;
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].id == currentTrialId) {
                trialIncart += cart.items[i].quantity;
              }
            }

            var data = {
              id: currentIdSub,
              quantity: currentQty,
              selling_plan: selling_plan,
            };

            console.log(data);

            // Add the subscription item to the cart
            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: data,
              dataType: "json",
              success: function () {
                openCart();
              },
              error: function () {
                alert("Error adding the subscription item to the cart.");
              },
            });
          });
        },
        error: function () {
          alert("Error clearing the cart.");
        },
      });
    }
  });

  $(".pmo_decline").click(function () {
    var currentId = $(this).attr("data-id");
    var items = [];
    items.push({ id: currentId, quantity: 1 });

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function () {
        openCart();
        $(".pmo_outer").hide();
      },
      error: function () {
        alert("Error adding the subscription item to the cart.");
      },
    });
  });

  $(".pmo_accept").click(function () {
    var currentId = $(this).attr("data-id");
    var items = [];

    // Add the main product
    items.push({ id: currentId, quantity: 1 });

    $(".pmo_product_card").each(function () {
      var $toggle = $(this).find('.pmo_switch input[type="checkbox"]');
      if ($toggle.is(":checked")) {
        var productId = $toggle.data("product-id");
        items.push({ id: productId, quantity: 1 });
      }
    });

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function () {
        openCart();
        $(".pmo_outer").hide();
      },
      error: function () {
        alert("Error adding the subscription item to the cart.");
      },
    });

    console.log(items, "ITEMS");
  });

  $(".slideToSummary").click(function (evt) {
    evt.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $(".qz_summary").offset().top - 100,
      },
      500
    );
  });

  $(".qz_results_insideCar").slick({
    dots: false,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_205.png?v=1730976741'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Frame_55.png?v=1730976741'/></button>",
    infinite: true,
    slidesToShow: 1,
  });

  $(document).scroll(function () {
    if ($(document).scrollTop() >= 600) {
      $(".sa_whole").addClass("active");
    } else {
      $(".sa_whole").removeClass("active");
    }
  });
});
